// src/utils/helpers/inputHandlers/mobileNumberHandler.ts

export const handleMobileNumberChange = (value: string) => {
  if (!value) return "";

  // Allow only numbers and "+"
  let cleaned = value.replace(/[^0-9+]/g, "");

  // Prevent more than one "+"
  if (cleaned.startsWith("++")) {
    cleaned = cleaned.replace(/\++$/, "");
  }

  // Only allow "+" at the beginning
  if (cleaned.includes("+") && !cleaned.startsWith("+")) {
    cleaned = cleaned.replace(/\+/g, "");
  }

  // Optional: Enforce +61 format
  if (cleaned.startsWith("+61")) {
    cleaned = "+61" + cleaned.slice(3).replace(/[^0-9]/g, "");
  }

  return cleaned;
};
